export default {"src":"/au/_next/static/media/weddingplannerpro_inco4.d179f6cc.svg","height":90,"width":78,"blurWidth":0,"blurHeight":0};